import { combineReducers } from 'redux'
import { formReducer, modelReducer } from 'react-redux-form'

import * as h2Api from '../h2Api'
import { REFER_EDUCATOR } from '../actions/educatorAccountReferralActions'

const initialState = {}
const initialNoteForm = {
  name: '',
  email: '',
  message: ''
}
const data = (state = initialState, action) => {
  switch (action.type) {
    default:
      return state
  }
}

export default combineReducers({
  data,
  requestDetail: h2Api.restReducer(REFER_EDUCATOR),
  educatorReferralForm: modelReducer(
    'educatorReferral.educatorReferralForm',
    initialNoteForm
  ),
  forms: formReducer('educatorReferral', {
    educatorReferralForm: initialNoteForm
  })
})
